import React from 'react';
import { Calendar, Sparkles, ArrowRight, Heart, Star } from 'lucide-react';

export function Booking({ onScrollTo, storefrontSettings }) {
    return (
        <section id="booking" className="py-24 bg-gradient-to-b from-white to-[#fdfbf7] relative overflow-hidden">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#fae1e5] rounded-full mix-blend-multiply filter blur-3xl opacity-30 -z-0"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#f3e6d5] rounded-full mix-blend-multiply filter blur-3xl opacity-30 -z-0"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-br from-[#c5a059]/10 to-[#d48c95]/10 rounded-full blur-3xl -z-0"></div>

            <div className="max-w-4xl mx-auto px-6 relative z-10">
                <div className="text-center">
                    {/* Icon */}
                    <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#c5a059] to-[#b08e4d] rounded-full mb-8 shadow-xl animate-pulse">
                        <Calendar className="text-white w-10 h-10" />
                    </div>

                    {/* Heading */}
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-gray-800 mb-6 leading-tight">
                        Ready to Transform
                        <br />
                        <span className="bg-gradient-to-r from-[#c5a059] via-[#d48c95] to-[#c5a059] bg-clip-text text-transparent">
                            Your Life?
                        </span>
                    </h2>

                    {/* Decorative line */}
                    <div className="h-1 w-32 bg-gradient-to-r from-[#d48c95] to-[#c5a059] mx-auto mb-8 rounded-full"></div>

                    {/* Description */}
                    <p className="text-gray-600 max-w-2xl mx-auto text-lg md:text-xl leading-relaxed mb-10">
                        Book your <span className="font-semibold text-[#c5a059]">1:1 coaching session</span> and start your journey towards
                        self-love, cultural healing, and personal transformation.
                    </p>

                    {/* Features */}
                    <div className="flex flex-wrap items-center justify-center gap-6 mb-12">
                        <div className="flex items-center gap-2 text-gray-600">
                            <Heart className="w-5 h-5 text-[#d48c95] fill-[#d48c95]" />
                            <span>Personalized guidance</span>
                        </div>
                        <div className="flex items-center gap-2 text-gray-600">
                            <Star className="w-5 h-5 text-[#c5a059] fill-[#c5a059]" />
                            <span>Safe & supportive space</span>
                        </div>
                        <div className="flex items-center gap-2 text-gray-600">
                            <Sparkles className="w-5 h-5 text-[#d48c95]" />
                            <span>Lasting transformation</span>
                        </div>
                    </div>

                    {/* CTA Button */}
                    <a
                        href="/storefront"
                        className="group inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-[#c5a059] via-[#b08e4d] to-[#c5a059] text-white text-lg md:text-xl font-semibold rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 relative overflow-hidden"
                    >
                        {/* Shine effect */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>

                        <Calendar className="w-6 h-6" />
                        <span>Book Your Session Today</span>
                        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" />
                    </a>

                    {/* Secondary text */}
                    <p className="mt-8 text-sm text-gray-500">
                        Choose from single sessions or our transformative 12-week programme
                    </p>
                </div>
            </div>
        </section>
    );
}

export default Booking;

